import React from 'react';
import { ChevronDown } from 'lucide-react';

interface SimpleSelectOption {
    label: string;
    value: string | number;
}

interface SimpleSamSelectProps {
    options: SimpleSelectOption[];
    label: string
    value?: string | undefined;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
}

export const SimpleSamSelect: React.FC<SimpleSamSelectProps> = ({
                                                                    options,
                                                                    value,
                                                                    onChange,
                                                                    placeholder = 'Select an option',
                                                                    disabled = false,
                                                                    className = '',
                                                                    label
                                                                }) => {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value);
    };

    // Base styles for the select wrapper
    const wrapperClasses = `
    relative rounded-md shadow-sm
    ${disabled ? 'opacity-60 cursor-not-allowed' : ''}
    ${className}
  `;

    // Base styles for the select element
    const selectClasses = `
    block w-full rounded-md border border-gray-300 p-2 text-sm
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
    disabled:bg-gray-100 disabled:cursor-not-allowed
    appearance-none bg-white
    relative z-10
  `;


    const id = `simple-sam-select-${label.toLowerCase()}`;
    return (
        <div>
            <label className="block text-sm font-medium mb-1" htmlFor={id}>{label}</label>
            <div className={wrapperClasses}>
                <select
                    id={id}
                    value={value?.toString() || ''}
                    onChange={handleChange}
                    disabled={disabled}
                    className={selectClasses}
                >
                    {(value === undefined || value === null) && (
                        <option value="" disabled>
                            {placeholder}
                        </option>
                    )}
                    {options.map((option) => (
                        <option key={`option-${option.value}`} value={option.value.toString()}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 z-0">
                    <ChevronDown className="h-5 w-5 text-gray-400" />
                </div>
            </div>
        </div>

    );
};
